var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7261_27881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9219 1.64062H9.87109V1.23047C9.87109 0.551988 9.31911 0 8.64062 0H5.35938C4.68089 0 4.12891 0.551988 4.12891 1.23047V1.64062H2.07812C1.39964 1.64062 0.847656 2.19261 0.847656 2.87109C0.847656 3.416 1.20381 3.87901 1.69545 4.04034L2.42703 12.8717C2.47972 13.5044 3.01834 14 3.65323 14H10.3468C10.9817 14 11.5203 13.5044 11.573 12.8715L12.3046 4.04031C12.7962 3.87901 13.1523 3.416 13.1523 2.87109C13.1523 2.19261 12.6004 1.64062 11.9219 1.64062ZM4.94922 1.23047C4.94922 1.00431 5.13321 0.820312 5.35938 0.820312H8.64062C8.86679 0.820312 9.05078 1.00431 9.05078 1.23047V1.64062H4.94922V1.23047ZM10.7555 12.8036C10.7379 13.0145 10.5584 13.1797 10.3468 13.1797H3.65323C3.44162 13.1797 3.26208 13.0145 3.24455 12.8038L2.52366 4.10156H11.4763L10.7555 12.8036ZM11.9219 3.28125H2.07812C1.85196 3.28125 1.66797 3.09725 1.66797 2.87109C1.66797 2.64493 1.85196 2.46094 2.07812 2.46094H11.9219C12.148 2.46094 12.332 2.64493 12.332 2.87109C12.332 3.09725 12.148 3.28125 11.9219 3.28125Z",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.35861 11.9239L4.94846 5.30667C4.93443 5.08056 4.73873 4.9086 4.51372 4.92268C4.28761 4.93671 4.1157 5.13134 4.1297 5.35742L4.53986 11.9746C4.55334 12.1921 4.73392 12.3594 4.94884 12.3594C5.18638 12.3594 5.37319 12.1594 5.35861 11.9239Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 4.92188C6.77348 4.92188 6.58984 5.10552 6.58984 5.33203V11.9492C6.58984 12.1757 6.77348 12.3594 7 12.3594C7.22652 12.3594 7.41016 12.1757 7.41016 11.9492V5.33203C7.41016 5.10552 7.22652 4.92188 7 4.92188Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.48631 4.92268C9.26073 4.90865 9.06558 5.08056 9.05158 5.30666L8.64142 11.9239C8.62745 12.1499 8.79936 12.3446 9.02543 12.3586C9.25165 12.3726 9.44617 12.2006 9.46017 11.9746L9.87033 5.35741C9.88433 5.13131 9.71242 4.93668 9.48631 4.92268Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7261_27881"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.0e9364f04d91390fce713d85d64afc00.svg";
export { ForwardRef as ReactComponent };